module.exports = __webpack_public_path__ + "img/lkw_busse_teaser.d6aeba00.jpg";